import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-principal-operario',
  templateUrl: './principal-operario.component.html',
  styleUrls: ['./principal-operario.component.css']
})
export class PrincipalOperarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
